import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { AnalysisAPIClient } from 'src/biz_spa/apiClients'
import type { ReviewSentence, QSCACategory } from 'src/biz_spa/types'
import type { Moment } from 'moment'

export const useQSCASentences = () => {
  const apiClient = new AnalysisAPIClient()
  const isLoading = ref(false)
  const positiveSentences = ref<ReviewSentence[]>([])
  const negativeSentences = ref<ReviewSentence[]>([])

  const route = useRoute()

  const companyUuid = computed(() => route.params.company_uuid as string)

  const readSentences = async (category: QSCACategory, startDate: Moment, endDate: Moment, storeUuids: string[]) => {
    isLoading.value = true

    try {
      const [positiveResponse, negativeResponse] = await Promise.all([
        apiClient.readSentences(companyUuid.value, {
          startDate,
          endDate,
          sentiment: 'POSITIVE',
          storeUuids,
          category,
        }),
        apiClient.readSentences(companyUuid.value, {
          startDate,
          endDate,
          sentiment: 'NEGATIVE',
          storeUuids,
          category,
        }),
      ])

      positiveSentences.value = positiveResponse
      negativeSentences.value = negativeResponse
    } finally {
      isLoading.value = false
    }
  }

  return {
    isLoading: computed(() => isLoading.value),
    positiveSentences: computed(() => positiveSentences.value),
    negativeSentences: computed(() => negativeSentences.value),
    readSentences,
  }
}
